import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetCardTransactionsRequest,
  DefaultApiUpdateUserAccountNameRequest,
  DefaultApiUpdateUserAccountGroupRequest,
  DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest,
  DefaultApiGetCardMonthlyTransactionsRequest,
  DefaultApiUpdateRemoveUserAccountGroupRequest,
  DefaultApiGetRolesWithTopRelatedResourcesRequest,
  DefaultApiCreateUserAccountGroupsRequest,
  DefaultApiReplaceVirtualCardRequest,
  DefaultApiUpdateUserUsageLimitRequest,
  DefaultApiUpdateDailyUserUsageLimitRequest,
  DefaultApiDisableUserUsageLimitRequest,
  DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest,
  DefaultApiBulkDisableDailyUserUsageLimitRequest,
  DefaultApiUpdateAvailableCurrenciesRequest,
  DefaultApiUpdateAvailableMerchantCategoriesRequest,
  DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getCanActivateCard = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return await userApiDefaultApiFactory(instance).getCanActivateCard({
    organizationId,
  })
}

export const getCards = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return await userApiDefaultApiFactory(instance).getCards({
    organizationId,
  })
}

export const getMonthlyUserCardSummaries = async (
  instance: AxiosInstance,
  organizationId: string,
  yearMonth: string
) => {
  return await userApiDefaultApiFactory(instance).getMonthlyUserCardSummaries({
    organizationId,
    yearMonth,
  })
}

export const getUserAccountGroups = async (
  instance: AxiosInstance,
  organizationId: string
) => {
  return await userApiDefaultApiFactory(instance).getUserAccountGroups({
    organizationId,
  })
}

export const getUserAccountsWithDefaultCommentTemplate = async (
  instance: AxiosInstance,
  organizationId: string
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getUserAccountsWithDefaultCommentTemplate({ organizationId })
}

export const getCurrentCardAssociatedWithTheUserAccount = async (
  instance: AxiosInstance,
  userAccountId: string
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getCurrentCardAssociatedWithTheUserAccount({ userAccountId })
}

export const getCardTransactions = async (
  instance: AxiosInstance,
  params: DefaultApiGetCardTransactionsRequest
) => {
  return await userApiDefaultApiFactory(instance).getCardTransactions(params)
}

export const updateUserAccountName = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateUserAccountNameRequest
) => {
  return await userApiDefaultApiFactory(instance).updateUserAccountName(params)
}

export const updateUserAccountGroup = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateUserAccountGroupRequest
) => {
  return await userApiDefaultApiFactory(instance).updateUserAccountGroup(params)
}

export const getCardMonthlyTransactions = async (
  instance: AxiosInstance,
  params: DefaultApiGetCardMonthlyTransactionsRequest
) => {
  return await userApiDefaultApiFactory(instance).getCardMonthlyTransactions(
    params
  )
}

export const getTheCountOfMonthlyTransactionsForTheUserAccount = async (
  instance: AxiosInstance,
  params: DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getTheCountOfMonthlyTransactionsForTheUserAccount(params)
}

export const updateRemoveUserAccountGroup = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateRemoveUserAccountGroupRequest
) => {
  return await userApiDefaultApiFactory(instance).updateRemoveUserAccountGroup(
    params
  )
}

export const getRolesWithTopRelatedResources = async (
  instance: AxiosInstance,
  params: DefaultApiGetRolesWithTopRelatedResourcesRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getRolesWithTopRelatedResources(params)
}

export const createUserAccountGroups = async (
  instance: AxiosInstance,
  params: DefaultApiCreateUserAccountGroupsRequest
) => {
  return await userApiDefaultApiFactory(instance).createUserAccountGroups(
    params
  )
}

export const replaceVirtualCard = async (
  instance: AxiosInstance,
  params: DefaultApiReplaceVirtualCardRequest
) => {
  return await userApiDefaultApiFactory(instance).replaceVirtualCard(params)
}

export const getAvailableMerchantCategoryOptions = async (
  instance: AxiosInstance
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getAvailableMerchantCategoryOptions()
}

export const getAvailableCurrencyOptions = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getAvailableCurrencyOptions()
}
export const updateUserUsageLimit = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateUserUsageLimitRequest
) => {
  return await userApiDefaultApiFactory(instance).updateUserUsageLimit(params)
}

export const disableUserUsageLimit = async (
  instance: AxiosInstance,
  params: DefaultApiDisableUserUsageLimitRequest
) => {
  return await userApiDefaultApiFactory(instance).disableUserUsageLimit(params)
}

export const bulkDisableDailyUserUsageLimit = async (
  instance: AxiosInstance,
  params: DefaultApiBulkDisableDailyUserUsageLimitRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).bulkDisableDailyUserUsageLimit(params)
}

export const updateDailyUserUsageLimit = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateDailyUserUsageLimitRequest
) => {
  return await userApiDefaultApiFactory(instance).updateDailyUserUsageLimit(
    params
  )
}

export const updateTransactionUpperLimitForTheUserAccount = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateTransactionUpperLimitForTheUserAccount(params)
}

export const updateAvailableCurrencies = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateAvailableCurrenciesRequest
) => {
  return await userApiDefaultApiFactory(instance).updateAvailableCurrencies(
    params
  )
}

export const updateAvailableMerchantCategories = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateAvailableMerchantCategoriesRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateAvailableMerchantCategories(params)
}

export const disableTransactionUpperLimitForTheUserAccount = async (
  instance: AxiosInstance,
  params: DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).disableTransactionUpperLimitForTheUserAccount(params)
}

// Do Not Remove this line ===@import api client===
